<template>
  <AppShell />
</template>

<script setup>
import AppShell from '@/components/AppShell.vue'
</script>
